import React from 'react';

const About = () => {
    return (
        <div className='footer bg-dark text-white mx-auto py-5 text-center align-items-center justify-content-cente'>
           <p>Copyright &copy 2022</p> 
           <p>All Rights Reserved.</p>

        </div>
    );
};

export default About;